import { useEffect, useState } from 'react'
import {  Grid, TextField,Button, Dialog, List, ListItem } from '@mui/material'
import MessageError from '../../../../messages/messageError'
import api from '../../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../../messages/messageSuccess'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import ButtonLeft from '../../../../utils/buttonLeft'
import Loading from '../../../../load/loading'


export default function CreateDocExpediente() {
    const [doc, setDoc] = useState('')
    const [docs, setDocs] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const user = useSelector(state => state.account.user);

    const [modal, setModal] = useState(false);
    const handleClose = () => {
        setModal(false);
        setErrorMessage('');
        setMessageSuccess('');
    }


    useEffect(() => {
        api.get('/expediente-docs')
            .then(res => {
                // console.log(res)
                setDocs(res.data.expedienteDocss);
            }).catch(err => '')
    }, [messageSuccess])

    function HandleChange(e) {
        setDoc({ ...doc, [e.target.name]: e.target.value })
    }

    async function createAdmin() {

        setLoad(true);
        setErrorMessage('');
        setMessageSuccess('');

        await api.post('/expediente-docs/add', { ...doc, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false);
                setMessageSuccess(res.data.msg);
                setDoc('');

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message);
                setLoad(false);
            })
    }


    return (
        <>
            <Button
                variant="contained"
                style={{ background: '#85287e' }}
                onClick={() => setModal(true)}
            >
                DOC
            </Button>
            
            <Dialog
                fullWidth
                open={!!modal}
                // TransitionComponent={Transition}
                // keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                scroll='body'
            >
                <div style={{ padding: 20 }}>

                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && < MessageError message={messageError} />}

                    {docs ?
                        <>
                            <HeaderGestorConfigs title='Tipos de documentos:' />
                            <List>
                                {docs.map((doc) => (
                                    <ListItem key={doc._id}>
                                        {doc.designacao}
                                    </ListItem>
                                ))}
                            </List>
                        </>
                        :
                        <Loading text={'A carregar docs'} />
                    }

                    <Grid container className="tw-items-end">

                        <Grid xs={12} md item className="tw-p-1">
                            <TextField
                                className="tw-mt-4"
                                type="text"
                                required
                                label="Criar novo tipo de documento"
                                fullWidth
                                size="small"
                                name="designacao"
                                variant="outlined"
                                onChange={HandleChange}
                            // defaultValue={doc?.designacao}
                            />
                        </Grid>

                        {/* <Grid xs={12} md item style={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            required
                            label="Sigla"
                            fullWidth
                            size="small"
                            name="sigla"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={doc?.Sigla}
                        />
                    </Grid> */}

                    </Grid>

                    <ButtonLeft
                        title={'Criar'}
                        load={load}
                        disabled={!doc?.designacao}
                        funcao={createAdmin}
                    />

                </div>
            </Dialog>
        </>
    )
}
